const styles = theme => ({
  continueShoppingLink: {
    display: "inline-block",
    marginTop: 16
  },
  circleWrapperDiv: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 16,
    marginBottom: 32
  }
});

export default styles;